import {
  APPLICATION_INITIALISED,
  APPLICATION_SET_LOADING,
  APPLICATION_SET_ERROR,
  NEXT_STATE,
  PREVIOUS_STATE,
  NEXT,
  PREVIOUS,
  LOAD_STEP,
  SET_STORES,
  SET_TYPES,
  SET_FIELDS,
  SET_APPOINTMENTS,
  SET_ICS_FILE,
  USER_SELECT_TYPE,
  USER_SELECT_CHILD,
  USER_SELECT_STORE,
  USER_FILTERED_STORE,
  USER_SELECT_SLOT,
  USER_UPDATE_FORM,
  USER_SUBMIT_FORM,
  SEND_EVENT,
  SET_MARKETING_STATE,
} from '@types'

export const appIsInitialised = () => ({
  type: APPLICATION_INITIALISED,
  payload: {},
})

export const appSetLoading = () => ({
  type: APPLICATION_SET_LOADING,
  payload: {},
})

export const appSetError = (type, props = {}) => ({
  type: APPLICATION_SET_ERROR,
  payload: { type, props },
})

export const nextState = (show = true, disabled = true, loading = false) => ({
  type: NEXT_STATE,
  payload: { show, disabled, loading },
})

export const previousState = (show = true, disabled = true, loading = false) => ({
  type: PREVIOUS_STATE,
  payload: { show, disabled, loading },
})

export const sendEvent = (key, data = {}) => ({
  type: SEND_EVENT,
  payload: { key, data },
})

export const next = () => ({
  type: NEXT,
  payload: {},
})

export const previous = () => ({
  type: PREVIOUS,
  payload: {},
})

export const loadStep = (step) => ({
  type: LOAD_STEP,
  payload: step,
})

export const setStores = (payload) => ({
  type: SET_STORES,
  payload,
})

export const setTypes = (payload) => ({
  type: SET_TYPES,
  payload,
})

export const setFields = (payload) => ({
  type: SET_FIELDS,
  payload,
})

export const setAppointments = (payload) => ({
  type: SET_APPOINTMENTS,
  payload,
})

export const userSelectType = (payload) => ({
  type: USER_SELECT_TYPE,
  payload,
})

export const userSelectChild = (payload) => ({
  type: USER_SELECT_CHILD,
  payload,
})

export const userSelectStore = (payload) => ({
  type: USER_SELECT_STORE,
  payload,
})

export const userFilteredStores = (payload) => ({
  type: USER_FILTERED_STORE,
  payload,
})

export const userSelectSlot = (payload) => ({
  type: USER_SELECT_SLOT,
  payload,
})

export const userUpdateForm = (payload) => ({
  type: USER_UPDATE_FORM,
  payload,
})

export const userSubmitForm = () => ({
  type: USER_SUBMIT_FORM,
  payload: {},
})


export const setIcsFile = (file) => ({
  type: SET_ICS_FILE,
  payload: file,
})


export const setMarketingState = (state) => ({
  type: SET_MARKETING_STATE,
  payload: state,
})
